import { useEffect, useState } from 'react';
import {
    AdaptivityProvider,
    AppRoot,
    View,
    Panel,
    PanelHeader,
    ConfigProvider,
    IconButton
} from '@vkontakte/vkui';
import ApiWidget from './components/ApiWidget';
import { Icon28HelpOutline } from '@vkontakte/icons';
import '@vkontakte/vkui/dist/vkui.css';
import bridge from '@vkontakte/vk-bridge';
import ModalShow from './components/ModalShow';

function App() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        bridge.send('VKWebAppInit');
    }, []);

    const AppTitle = 'Виджет «За Христа Пострадавшие»';

    return (
        <ConfigProvider>
            <AdaptivityProvider>
                <AppRoot>
                    <View activePanel="main">
                        <Panel id="main">
                            <PanelHeader>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{ marginRight: 'auto' }}>
                                        {AppTitle}
                                    </div>
                                    <div>
                                        <IconButton aria-label="Ответы на вопросы" onClick={() => setOpen(true)}>
                                            <Icon28HelpOutline />
                                        </IconButton>
                                    </div>
                                </div>
                            </PanelHeader>
                            <ApiWidget />
                            <ModalShow
                                open={open}
                                setOpen={setOpen}
                            />
                        </Panel>
                    </View>
                </AppRoot>
            </AdaptivityProvider>
        </ConfigProvider>
    );
}

export default App;
